import { IncomingMailDTO } from "../../models/incoming-mail/incoming-mail-dto";
import { BaseApiService } from "../base";
import { IncomingMailSTO } from "../../models/incoming-mail/incoming-mail-sto";

export class IncomingMailApiService extends BaseApiService<IncomingMailDTO, IncomingMailSTO> {
  constructor() {
    super({
      servicePath: "/IncomingMail",
      loadItemsPath: "/GetIncomingMails",
      saveItemsPath: "/SaveIncomingMails",
    });
  }
}
